import React, { useState, useEffect } from 'react';
import { GameCard } from './GameCard';
import gamesFeed from '../data/gamesFeed.json';

export const RandomGameCard: React.FC = () => {
  const [randomGame, setRandomGame] = useState<any>(null);

  useEffect(() => {
    if (gamesFeed && gamesFeed.length > 0) {
      const randomIndex = Math.floor(Math.random() * gamesFeed.length);
      setRandomGame(gamesFeed[randomIndex]);
    }
  }, []);

  if (!randomGame) return null;

  return (
    <div style={{ margin: '40px 0', width: '100%' }}>
      <div style={{ 
        padding: '30px', 
        background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', 
        borderRadius: '15px', 
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <h2 style={{ margin: '0 0 20px 0', fontSize: '2rem', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>🎲 Feeling Lucky?</h2>
        <div style={{ width: '100%', maxWidth: '400px' }}>
          <GameCard 
            id={randomGame.id}
            title={randomGame.title}
            category={randomGame.category}
            thumbnail={randomGame.thumbnail}
            badge="Random Pick"
          />
        </div>
      </div>
    </div>
  );
};
